import { render } from "./ArgonPagination.vue?vue&type=template&id=09d5b594"
import script from "./ArgonPagination.vue?vue&type=script&lang=js"
export * from "./ArgonPagination.vue?vue&type=script&lang=js"
script.render = render

export default script